import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class CompanyNetworkUserRoute extends Route {
  @service('commands.user-commands') userCommandService;
  @service('commands.company-commands') companyCommandService;
  @service router;
  @service session;

  async model() {
    const { companyId } = this.paramsFor('company-profile');

    const company = await this.companyCommandService.loadCompany(companyId, ['location', 'brands.image']);
    const user = await this.userCommandService.getUser(this.session.currentUser.id, [`company-seller-connections:company_id(${company.id})`]);

    return { user, company };
  }

  afterModel() {
    if (!this.session.currentUser.isSeller) {
      this.router.replaceWith(EMBER_ROUTE_NAMES.COMPANY_PROFILE);
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/company/:id/view');
  }
}

export default CompanyNetworkUserRoute;
